import axios from "axios";
import csrfHelper from "./csrfHelper";
import serverTimeHelper from "./serverTimeHelper";
const instance = axios.create();
let serverTime = serverTimeHelper.get();

let csrfToken = null;
let csrfPromise = null; // in-flight promise lock

async function getCsrfToken() {
  if (csrfToken) return csrfToken;

  if (!csrfPromise) {
    csrfPromise = csrfHelper.get().then(token => {
      csrfToken = token;
      csrfPromise = null; // reset lock
      return token;
    }).catch(err => {
      csrfPromise = null; // reset lock on error
      throw err;
    });
  }

  return csrfPromise;
}

instance.interceptors.request.use(async function(conf){
   const token = await getCsrfToken();
   // console.log("after csrf get");
   conf.headers['X-CSRF-TOKEN'] = token;
   return conf;
})

instance.interceptors.response.use(async function (res) {   return res; },async (error)=>{
   if( error.response.status === 401){
  let {response} = error;
  let {data} = response;
  let {message} = data;
   if(message !== undefined){
      if(message === "CSRF Token Expired"){
         await csrfHelper.refresh();
      }
   }
}
   return Promise.reject(error);
});
export default instance;